import React, {useState} from "react"
import theme from "@irati/ui/src/global/theme"
import {PrimaryModal, Wrapper, Close} from "@irati/ui/src/GenericModal/styled"
import NewRewardWalletContent from "./NewRewardWalletContent"

const NewRewardModal = () => {
  const [show, setShow] = useState(true)
  const closeModal = () => setShow(false)
  return (
    <PrimaryModal show={show} onHide={closeModal}>
      <Wrapper direction="column">
        <Close inline={false} onClick={closeModal} color={theme.colors.greys.white} />
        <NewRewardWalletContent onHide={closeModal} />
      </Wrapper>
    </PrimaryModal>
  )
}

export default NewRewardModal
